module.exports = __webpack_public_path__ + "static/img/研究生工作站_1.375adeed.jpg";